import Vue from 'vue'
import Vuex from 'vuex'
import quality from './modules/quality'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        quality
    },
    
    
    state: {
        isOverLogin:false,
        baseUrl: localStorage.getItem("baseURL"),
        webSocketUrl: localStorage.getItem("webSocketUrl"),
        // baseUrl: 'http://10.0.14.247:8017',
        // webSocketUrl: '10.0.14.247:8017',
        // baseUrl: 'http://10.8.211.201:8017',
        // webSocketUrl: 'http://10.8.211.201:8017',
        // baseUrl: 'http://10.8.206.199:31003',
        // webSocketUrl: '10.8.206.199:36100',// 郭海良
        // baseUrl: 'http://localhost:8017',
        // webSocketUrl: 'localhost:8017',
        // baseUrl: 'http://10.8.206.199:36002',
        // webSocketUrl: '10.8.206.199:36002',// 郭海良
        // baseUrl: 'http://10.8.211.201:8017',
        // webSocketUrl: '10.8.211.201:8017',
        userName: '',
        icv_view:[],
        icv_exam:[],
        rn_view:[],
        rn_exam:[],
        tp_view:[],
        roadWidth: [1,2,3,4,5,6,7,8,9,10,11,12,13,14],
        deviationUnit: 0.3,
        workTypeList: {
            0: '未选择',
            11: '手动压实',
            21: '手动摊铺压实',
            1: '智能压实',
            2: '无人压实',
            3: '智能摊铺压实',
            4: '无人摊铺压实'
        },
        equipTypeList:[],
        statusList:{
            0: '空闲',
            1: '作业中',
            2: '完成',
        },
        arrowList: [{
            name: '首页',
            path: '/'
        }],
        roadType: [
            // {
            //     label: '全部',
            //     value: ""
            // },
            {
                label: '标准道路(高速公路、市区道路等)',
                value: 0
            },
            {
                label: '非标准道路(大坝、机场等)',
                value: 1
            }
        ],
        projectType:[
            {
                label: '道路施工',
                value: 0
            },
            {
                label: '土方压实',
                value: 1
            }
        ],
        projectTypeAll:[
            {
                label: '全部',
                value: ""
            },
            {
                label: '道路施工',
                value: 0
            },
            {
                label: '土方压实',
                value: 1
            }
        ],
        roadTypeOutAll: [{
                label: '标准道路(高速公路、市区道路等)',
                value: 0
            },
            {
                label: '非标准道路(大坝、机场等)',
                value: 1
            }
        ],
        nowRoadId: '',
        scaleCode: '',
        zoom: '',
        // 遍数颜色
        rollNumColor:{
            '1': 'rgb(200,200,255)',
            '2': 'rgb(150,150,255)',
            '3': 'rgb(100,100,255)',
            '4': 'rgb(50,50,255)',
            '5': 'rgb(0,0,255)',
            '6': 'rgb(17,85,255)',
            '7': 'rgb(33,170,255)',
            '8': 'rgb(50,255,255)',
            '9': 'rgb(25,255,255)',
            '10': 'rgb(0,255,0)',
            '11': 'rgb(50,255,0)',
            '12': 'rgb(100,255,0)',
            '13': 'rgb(150,255,0)',
            '14': 'rgb(200,255,0)',
            '15': 'rgb(255,255,0)',
            '16': 'rgb(255,200,0)',
            '17': 'rgb(255,150,0)',
            '18': 'rgb(255,100,0)',
            '19': 'rgb(255,50,0)',
            '20': 'rgb(255,0,0)',
        },
        rollNumColorArr:[
            'rgb(200,200,255)',
            'rgb(150,150,255)',
            'rgb(100,100,255)',
            'rgb(50,50,255)',
            'rgb(0,0,255)',
            'rgb(17,85,255)',
            'rgb(33,170,255)',
            'rgb(50,255,255)',
            'rgb(25,255,255)',
            'rgb(0,255,0)',
            'rgb(50,255,0)',
            'rgb(100,255,0)',
            'rgb(150,255,0)',
            'rgb(200,255,0)',
            'rgb(255,255,0)',
            'rgb(255,200,0)',
            'rgb(255,150,0)',
            'rgb(255,100,0)',
            'rgb(255,50,0)',
            'rgb(255,0,0)',
        ],
        // 压实度颜色
        icvColor:{
            '64': 'rgb(255,0,0)',
            '74': 'rgb(255,85,0)',
            '84': 'rgb(255,170,0)',
            '94': 'rgb(255,255,0)',
            '100': 'rgb(0,255,0)',
        },
        icvColorArr:[
            'rgb(255,0,0)',
            'rgb(255,85,0)',
            'rgb(255,170,0)',
            'rgb(255,255,0)',
            'rgb(0,255,0)',
        ],
        // 摊铺温度颜色
        pavColor:{
            '95': 'rgb(125,125,125)',
            '115': 'rgb(50,50,255)',
            '135': 'rgb(50,255,255)',
            '150': 'rgb(0,255,0)',
            '165': 'rgb(255,0,0)',
            '200': 'rgb(255,0,255)',
        },
        pavColorArr:[
            'rgb(125,125,125)',
            'rgb(50,50,255)',
            'rgb(50,255,255)',
            'rgb(0,255,0)',
            'rgb(255,0,0)',
            'rgb(255,0,255)'
        ],
        // 碾压温度颜色
        rollColor:{
            '95': 'rgb(125,125,125)',
            '115': 'rgb(50,50,255)',
            '135': 'rgb(50,255,255)',
            '150': 'rgb(0,255,0)',
            '165': 'rgb(255,0,0)',
            '200': 'rgb(255,0,255)',
        },
        rollColorArr:[
            'rgb(125,125,125)',
            'rgb(50,50,255)',
            'rgb(50,255,255)',
            'rgb(0,255,0)',
            'rgb(255,0,0)',
            'rgb(255,0,255)'
        ],
        projectId: ''
    },

    mutations: {
        setOverLogin(state, params) {
            state.isOverLogin = params
          },
        setRn_view(state, project) {
            //console.log(project)
            if (project) {
                state.rn_view.push(project)
                // let arr=[]
                // for(var i=0; i<state.rn_view.length; i++){
                //     if(state.rn_view[i].conetent.size>1000){
                //         arr.push(state.rn_view[i]);
                //     }
                // }
                // state.rn_view=arr
            }else{
                state.rn_view=[];
            }
        },
        setRn_exam(state, project) {
            //console.log(project)
            if (project) {
                state.rn_exam.push(project)
            }else{
                state.rn_exam=[];
            }
        },
        setIcv_view(state, project) {
            if (project) {
                state.icv_view.push(project)
                // let arr=[]
                // for(var i=0; i<state.icv_view.length; i++){
                //     if(state.icv_view[i].conetent.size>1000){
                //         arr.push(state.icv_view[i]);
                //     }
                // }
                // state.icv_view=arr
            }else{
                state.icv_view=[];
            }
        },
        setIcv_exam(state, project) {
            //console.log(project)
            if (project) {
                state.icv_exam.push(project)
            }else{
                state.icv_exam=[];
            }
        },
        setTp_view(state, project) {
            if (project) {
                state.tp_view.push(project)
                // let arr=[]
                // for(var i=0; i<state.tp_view.length; i++){
                //     if(state.tp_view[i].conetent.sizes>1000){
                //         arr.push(state.tp_view[i]);
                //     }
                // }
                // state.tp_view=arr
            }else{
                state.tp_view=[];
            }
        },
        setArrowList(state, project) {
            //console.log(project)
            if (project) {
                state.arrowList = project
            }
        },
        setNowRoadId(state, project) {
            if (project) {
                state.nowRoadId = project
            }
        },
        setScaleCode(state, project) {
            if (project) {
                state.scaleCode = project
            }
        },
        setZoom(state, project) {
            if (project) {
                state.zoom = project
            }
        },
        setUserName(state, project) {
            if (project) {
                state.userName = project
            }
        },
        setRoadWidth(state, project) {
            if (project) {
                state.roadWidth = project
            }
        },
        deviationUnit(state, project) {
            if (project) {
                state.deviationUnit = project
            }
        },
        setRollNumColorArr(state,project){
            if (project) {
                state.rollNumColorArr = project;
            }
        },
        setRollNumColor(state,project){
            if(project){
                state.rollNumColor = project;
            }
        },
        setIcvColor(state,project){
            if(project){
                state.icvColor = project;
            }
        },
        setIcvColorArr(state,project){
            if(project){
                state.icvColorArr = project;
            }
        },
        setPavColor(state,project){
            if(project){
                state.pavColor = project;
            }
        },
        setPavColorArr(state,project){
            if(project){
                state.pavColorArr = project;
            }
        },
        setRollColor(state,project){
            if(project){
                state.rollColor = project;
            }
        },
        setRollColorArr(state,project){
            if(project){
                state.rollColorArr = project;
            }
        },
        setEquipTypeList(state,project){
            if(project){
                state.equipTypeList = project;
            }
        },
        setProjectId(state,project){
            if(project){
                state.projectId = project;
            }
        },
    },
    actions: {

    }
})